module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/basic-buttons/basic-buttons.component.scss
// module id = ./src/app/features/buttons/basic-buttons/basic-buttons.component.scss
// module chunks = main